import { AvailabilitySearchQuery } from 'types';
import { SearchQueryStringParams } from 'components/search/utils';
import { setDefaultSearchQueryParams } from 'utils/citySearchUtils';
import { useCurrentMetroArea } from 'hooks/useCurrentMetroArea';
import { useMemo } from 'react';
import { useQueryStringParams } from 'hooks/useQueryStringParams';
import { useRoutedCollectionPageInfo } from 'selectors/consumerPageSelectors';

export function useFlatSearchQuery(): AvailabilitySearchQuery {
  const currentMetroArea = useCurrentMetroArea();
  const queryStringParams = useQueryStringParams<SearchQueryStringParams>();
  const { id: collectionId } = useRoutedCollectionPageInfo();
  const flatSearchQuery = useMemo(() => {
    const availabilitySearchQuery = setDefaultSearchQueryParams(
      queryStringParams,
      currentMetroArea?.timezone ?? 'US/Central',
      { collectionId }
    );

    return availabilitySearchQuery;
  }, [collectionId, currentMetroArea, queryStringParams]);

  return flatSearchQuery;
}
